import React, { useLayoutEffect } from "react";
import { Grid2, Stack, Typography } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";

import { LottieIcon, PageContainer } from "src/shared/ui";
import { LottieIconNames } from "src/shared/config";
import { useAppDispatch, useAppSelector } from "src/shared/hooks";
import { blogsModel } from "src/entities/blogs";
import { BlogItem } from "src/widgets/BlogItem";

import "react-quill-new/dist/quill.snow.css";

export const BlogPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const blogs = useAppSelector(blogsModel.selectors.selectBlogs);

  useLayoutEffect(() => {
    dispatch(blogsModel.thunks.getBlogs());
  }, []);

  return (
    <PageContainer
      hidden
      mainComponent={
        <>
          <Stack
            width={1}
            height={1}
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
            zIndex={99}
            sx={{
              alignItems: {
                xs: "center",
                sm: "flex-start",
              },
            }}
          >
            <Typography
              variant="h1"
              fontWeight="bold"
              color={blueGrey[700]}
              textTransform="uppercase"
              textAlign="center"
            >
              Blog
            </Typography>

            <Typography
              variant="h5"
              color={grey[700]}
              textAlign="start"
              textTransform="uppercase"
              whiteSpace="pre-wrap"
              sx={{
                textAlign: {
                  xs: "center",
                  sm: "start",
                },
              }}
            >
              Calendar of MathrixAI {"\n"}Major Upcoming Events {"\n"}2025
            </Typography>
          </Stack>

          <Stack
            sx={{
              display: {
                xs: "none",
                sm: "flex",
              },
            }}
          >
            <LottieIcon
              icon={LottieIconNames.BLOG}
              autoPlay
              loop
              style={{
                position: "absolute",
                height: "calc(100% - 180px)",
                transform: "translateX(150px)",
                top: 0,
                right: 0,
              }}
            />
          </Stack>
        </>
      }
    >
      <Grid2
        container
        maxWidth="lg"
        columns={{ lg: 2, md: 2, sm: 2 }}
        spacing={4}
      >
        {blogs.map((blog) => (
          <BlogItem key={blog.id} blog={blog} />
        ))}
      </Grid2>
    </PageContainer>
  );
};
